import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LoginPage.css'; // Reusing Login styles for consistency
import { resetPasswordForEmail } from '../services/authService';

const EMAIL_REGEX = /\S+@\S+\.\S+/;
const REDIRECT_URL = 'https://student-leaderboard-five.vercel.app/update-password';

function ResetPasswordRequest() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [emailError, setEmailError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setError('');
        setEmailError('');

        if (!EMAIL_REGEX.test(email)) {
            setEmailError('Please enter a valid email');
            return;
        }

        try {
            setLoading(true);
            const { error } = await resetPasswordForEmail(email, REDIRECT_URL);

            if (error) {
                throw error;
            }

            setMessage('Check your email for the password reset link.');
        } catch (err) {
            setError(err.message || 'Failed to send reset email. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (emailError) setEmailError('');
    };

    return (
        <div className="login-page-container" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 10, margin: 0, borderRadius: 0 }}>
            <div className="login-header">
                <div className="login-logo">Task Square (Beta)</div>
            </div>

            <div className="login-form-card">
                <h2>Reset Password</h2>
                <p className="login-subtitle">Enter your email to receive a reset link</p>

                <form onSubmit={handleSubmit}>
                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="error-message">{error}</p>}

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={handleEmailChange}
                            required
                            className={emailError ? 'input-error' : ''}
                            disabled={loading}
                            placeholder="name@example.com"
                        />
                        {emailError && <p className="error-message">{emailError}</p>}
                    </div>

                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div className="login-footer">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
}

export default ResetPasswordRequest;
